/* Dynamische verzendmelding — kiest de tekst op basis van NL-tijd (Europe/Amsterdam),
   client-side zodat het klopt ondanks paginacaching en de tijdzone van de bezoeker.

   Logica: verstuurt vandaag als het een VERZENDDAG is (ma–vr, geen feestdag) én
   het is vóór de cutoff. Anders wordt de eerstvolgende verzenddag gezocht
   (weekend + feestdagen worden overgeslagen) en genoemd.

   Data-attributen per element ([data-spd-verzendmelding]):
     data-week       tekst bij "vandaag verzonden" ({tijd} → cutoff, bijv. 15.00)
     data-later      tekst bij latere verzending ({dag} → eerstvolgende verzenddag)
     data-cutoff     cutoff-tijd "uu:mm" (default 15:00)
     data-feestdagen extra sluitingsdagen, komma/spatie-gescheiden JJJJ-MM-DD
   De standaard NL-feestdagen worden automatisch berekend (incl. Pasen-afgeleiden). */
(function () {
  // Gelokaliseerde dagnaam via Intl, op basis van de paginataal (data-locale).
  // 'd' heeft al NL-lokale velden (zie nlNu) → GÉÉN timeZone meegeven, anders
  // dubbele conversie. nl → 'maandag', de → 'Montag', en → 'Monday'.
  function dagNaam(d, locale) {
    try {
      return new Intl.DateTimeFormat(locale || 'nl', { weekday: 'long' }).format(d);
    } catch (e) {
      return new Intl.DateTimeFormat('nl', { weekday: 'long' }).format(d);
    }
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function key(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function plusDagen(d, n) { var r = new Date(d); r.setDate(r.getDate() + n); return r; }

  // Eerste paasdag (Anonymous Gregorian algorithm).
  function paasZondag(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7,
        m = Math.floor((a + 11 * h + 22 * l) / 451), maand = Math.floor((h + l - 7 * m + 114) / 31),
        dag = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, maand - 1, dag);
  }

  // Standaard NL-feestdagen waarop niet verzonden wordt (carriers rijden niet).
  function standaardFeestdagen(y, set) {
    function add(d) { set[key(d)] = 1; }
    var pasen = paasZondag(y);
    add(new Date(y, 0, 1));           // Nieuwjaarsdag
    add(plusDagen(pasen, 1));         // Tweede Paasdag
    add(plusDagen(pasen, 39));        // Hemelvaartsdag
    add(plusDagen(pasen, 50));        // Tweede Pinksterdag
    var kon = new Date(y, 3, 27);     // Koningsdag (26 apr als 27 een zondag is)
    if (kon.getDay() === 0) kon = new Date(y, 3, 26);
    add(kon);
    add(new Date(y, 11, 25));         // Eerste Kerstdag
    add(new Date(y, 11, 26));         // Tweede Kerstdag
  }

  function nlNu() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
  }

  function parseCutoff(s) {
    var m = /(\d{1,2})[:.h](\d{2})/.exec(s || '');
    return m ? { u: +m[1], m: +m[2] } : { u: 15, m: 0 };
  }

  function isVerzenddag(d, feest) {
    var dag = d.getDay();
    if (dag === 0 || dag === 6) return false;   // weekend
    return !feest[key(d)];                        // geen feest-/sluitingsdag
  }

  function verwerk(el) {
    var now = nlNu();
    var cutoff = parseCutoff(el.getAttribute('data-cutoff'));

    // Feestdagen: standaard voor dit + volgend jaar, plus extra uit de setting.
    var feest = {};
    var jr = now.getFullYear();
    standaardFeestdagen(jr, feest);
    standaardFeestdagen(jr + 1, feest);
    (el.getAttribute('data-feestdagen') || '').split(/[\s,;]+/).forEach(function (x) {
      x = x.trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(x)) feest[x] = 1;
    });

    var voorCutoff = now.getHours() < cutoff.u
      || (now.getHours() === cutoff.u && now.getMinutes() < cutoff.m);
    var vandaagVerzonden = isVerzenddag(now, feest) && voorCutoff;

    var cutoffTekst = cutoff.u + '.' + pad(cutoff.m); // bijv. "15.00"

    if (vandaagVerzonden) {
      var w = el.getAttribute('data-week') || 'Voor [tijd] uur besteld, vandaag verzonden';
      el.textContent = w.replace('[tijd]', cutoffTekst);
      return;
    }

    // Eerstvolgende verzenddag zoeken (vanaf morgen).
    var d = plusDagen(now, 1), guard = 0;
    while (!isVerzenddag(d, feest) && guard < 21) { d = plusDagen(d, 1); guard++; }

    var later = el.getAttribute('data-later') || 'Vandaag besteld, [dag] verzonden';
    el.textContent = later.replace('[dag]', dagNaam(d, el.getAttribute('data-locale'))).replace('[tijd]', cutoffTekst);
  }

  function toepassen() {
    var els = document.querySelectorAll('[data-spd-verzendmelding]');
    for (var i = 0; i < els.length; i++) verwerk(els[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', toepassen);
  else toepassen();
})();
